/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitesubexpiredtitle3Inputs */



/**
* | output |
* | --- |
* | "Enjoyed the 'Monster' subscription?" |
*
* @param {Invitesubexpiredtitle3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const invitesubexpiredtitle3 = /** @type {((inputs?: Invitesubexpiredtitle3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitesubexpiredtitle3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Enjoyed the 'Monster' subscription?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Te gustó la suscripción «Monster»?")
	return /** @type {LocalizedString} */ ("Понравилась подписка «Монстр»?")
});
export { invitesubexpiredtitle3 as "inviteSubExpiredTitle" }